
import TableList from "@components/templates/tablelist";
// import { HttpQueryReserveSku } from '@/service/setting';
import { HttpPlanBillErpSku } from '@/service/allotment';

import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    props:['lineId', 'orgWarehouseId', 'operateType', 'inventoryType'],
    data() {
        return {
            isMixin: true,
            formData: {
                search: {
                },
            },
            line: '',
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillErpSku,
        interceptRequest(params) {
            params.lineId = params.search.EQ_lineId
            // params.search.EQ_enable = 1
            params.search.EQ_inventoryType = this.inventoryType || 0
            params.search.EQ_orgWarehouseId = this.orgWarehouseId
            delete params.search.EQ_lineId;
            return params
        },
    },
    computed: {
		...mapGetters('dictionary', ['getProductList', 'getCusproductList']),
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },
            {
                label: this.$t('global.common.name', { defaultValue: "名称" }),
                tag: 'vInput',
                key: 'EQ_name',
                show: true,
            },
            {
                label: this.$t('global.common.project', { defaultValue: "项目" }),
                key: 'EQ_lineId',
                tag: 'vSelect',
                options: this.getProductList.map((item) => {
					return {
						value: item.value,
						label: item.attach.name,
					}
				}),
                props:{
                    filterable:true,
                },
                show: true,
                default: this.lineId || ''
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: "名称",
                key: 'productName'
            },
            {
                title: "可用库存",
                width: this.operateType == 'amazonOut' ? 0 : 265,
                key: 'inventoryAvailable',
            },
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
